import React from "react";
import SafeIcon from "../../../common/SafeIcon";
import { FiFilter, FiRotateCcw, FiSearch } from "react-icons/fi";

const categories = [
  ["general", "General"],
  ["tax", "Tax"],
  ["bank_statement", "Bank statement"],
  ["financial_statement", "Financial statement"],
  ["contract", "Contract"],
  ["invoice", "Invoice"],
  ["receipt", "Receipt"],
  ["payroll", "Payroll"],
  ["legal", "Legal"],
  ["other", "Other"],
];

export default function ClientDocumentFilters({
  search,
  category,
  visibility,
  sortDirection,
  onChange,
  onReset,
}) {
  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
      <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-[minmax(220px,1fr)_repeat(3,minmax(150px,190px))_auto]">
        <label className="relative">
          <span className="sr-only">Search documents</span>
          <SafeIcon icon={FiSearch} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <input
            value={search}
            onChange={(event) => onChange("search", event.target.value)}
            placeholder="Search file names"
            className="h-11 w-full rounded-xl border border-slate-200 pl-10 pr-3 text-sm outline-none transition focus:border-violet-400 focus:ring-2 focus:ring-violet-100"
          />
        </label>
        <label>
          <span className="sr-only">Filter by category</span>
          <select value={category} onChange={(event) => onChange("category", event.target.value)} className="h-11 w-full rounded-xl border border-slate-200 bg-white px-3 text-sm text-slate-700 outline-none focus:border-violet-400">
            <option value="all">All categories</option>
            {categories.map(([value, label]) => <option key={value} value={value}>{label}</option>)}
          </select>
        </label>
        <label>
          <span className="sr-only">Filter by visibility</span>
          <select value={visibility} onChange={(event) => onChange("visibility", event.target.value)} className="h-11 w-full rounded-xl border border-slate-200 bg-white px-3 text-sm text-slate-700 outline-none focus:border-violet-400">
            <option value="all">All visibility</option>
            <option value="shared_with_accountant">Shared with accountant</option>
            <option value="client_only">Private</option>
          </select>
        </label>
        <label>
          <span className="sr-only">Sort documents by upload date</span>
          <select value={sortDirection} onChange={(event) => onChange("sortDirection", event.target.value)} className="h-11 w-full rounded-xl border border-slate-200 bg-white px-3 text-sm text-slate-700 outline-none focus:border-violet-400">
            <option value="desc">Newest first</option>
            <option value="asc">Oldest first</option>
          </select>
        </label>
        <button type="button" onClick={onReset} className="inline-flex h-11 items-center justify-center gap-2 rounded-xl border border-slate-200 px-4 text-sm font-semibold text-slate-600 transition hover:bg-slate-50">
          <SafeIcon icon={FiRotateCcw} /> Reset
        </button>
      </div>
      <p className="mt-3 flex items-center gap-2 text-xs text-slate-400">
        <SafeIcon icon={FiFilter} /> Filters apply to active documents in this business.
      </p>
    </section>
  );
}